import { Component } from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {SitesService} from "../sites.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "../../translate";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "../../lib/helper.service";
import { ITotals } from "../../models/responce_result.model";

interface IMXData extends ITotals {
	desktop: number;
	tablet: number;
	phone: number;
}

interface IMXResult extends ITotals {
	total: IMXData;
	avg: IMXData;
}


@Component({
  selector: 'app-mx',
  templateUrl: './mx.component.html'
})
export class MxComponent  extends BaseComponent {
	data = {
		total: {
			desktop: 0,
			tablet: 0,
			phone: 0,
		},
		avg: {
			desktop: 0,
			tablet: 0,
			phone: 0,
		}
	};
	
	
	constructor(
		public eventsService: EventsService,
			public sitesService: SitesService,
			public activatedRoute: ActivatedRoute,
			public translate: TranslateService,
			public router: Router,
			public filter: FilterFormService,
			public http: HttpClient,
			public helper: HelperService
	) {
		super(eventsService, sitesService, activatedRoute, filter, translate);
	}

	
	async getData() {
		this.isLoad = true;
		
		const { total, avg } = await this.sitesService.mx.total<IMXResult>(
			this.filter.filterParams
		).toPromise();
		
		this.data.total = total;
		this.data.avg = avg;

		this.isLoad = false;
	}
}
